import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'

import { Container, Grid, GridColumn, Button, Icon, Input, Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, Loader, Select, Segment, Label } from 'semantic-ui-react'

const locations = [
    { key: 'paya-lebar', text: 'Paya Lebar', value: 'Paya Lebar' },
    { key: 'tai-seng', text: 'Tai Seng', value: 'Tai Seng' },
    { key: 'woods-square', text: 'Woods Square', value: 'Woods Square' },
    { key: 'unassigned', text: 'Unassigned', value: '__UNASSIGNED__' }
]

class DocumentLocations extends Component {
    state = {
        selectedLocation: 'Paya Lebar',
        isSearching: false,
        searchString: ''
    }

    componentDidMount() {
        if (!this.props.clients) {
            this.props.fetchClients()
        }
    }

    getDocCountOfStatus = (status, records) => {
        let count = 0
        for (const record of records || []) {
            for (const doc of record.docs || []) {
                if (doc.status === status) count += 1
            }
        }
        return count
    }

    getRecordLocation = (record) => {
        if (!record || !record.docs || record.docs.length === 0) {
            return '__UNASSIGNED__'
        }

        for (const doc of record.docs) {
            if (doc && typeof doc.location === 'string' && doc.location.trim().length > 0) {
                return doc.location
            }
        }

        return '__UNASSIGNED__'
    }

    buildLocationRows = (locationValue) => {
        const rows = []

        if (!this.props.clients) return rows

        for (const client of this.props.clients) {
            if (!client || !client.clientInfo || !client.clientDocs) continue
            if (!client.clientDocs.length) continue

            // Filter records that belong to this location
            const matchingRecords = []
            for (const record of client.clientDocs) {
                const recordLocation = this.getRecordLocation(record)
                if (locationValue === '__UNASSIGNED__') {
                    if (recordLocation === '__UNASSIGNED__') {
                        matchingRecords.push(record)
                    }
                } else {
                    if (recordLocation === locationValue) {
                        matchingRecords.push(record)
                    }
                }
            }

            if (matchingRecords.length === 0) continue

            // Optional search (company name / group / ROC)
            if (this.state.isSearching) {
                const needle = (this.state.searchString || '').toLowerCase()
                const companyName = (client.clientInfo.companyName || '').toLowerCase()
                const group = (client.clientInfo.group || '').toLowerCase()
                const roc = (client.clientInfo.roc || '').toLowerCase()

                const hit = companyName.includes(needle) || group.includes(needle) || roc.includes(needle)
                if (!hit) continue
            }

            const received = this.getDocCountOfStatus('Received', matchingRecords)
            const processing = this.getDocCountOfStatus('In Processing', matchingRecords)
            const ready = this.getDocCountOfStatus('Ready to Return', matchingRecords)
            const returned = this.getDocCountOfStatus('Returned', matchingRecords)
            const total = received + processing + ready + returned

            rows.push(
                <TableRow key={client._id}>
                    <TableCell>
                        {client.clientInfo.companyName}
                        {this.state.selectedLocation === '__UNASSIGNED__' && (
                            <Label
                                size="mini"
                                basic
                                color="orange"
                                style={{ marginLeft: 8 }}
                            >
                                Needs location
                            </Label>
                        )}
                    </TableCell>
                    <TableCell>{client.clientInfo.roc}</TableCell>
                    <TableCell collapsing>{received}</TableCell>
                    <TableCell collapsing>{processing}</TableCell>
                    <TableCell collapsing>{ready}</TableCell>
                    <TableCell collapsing>{returned}</TableCell>
                    <TableCell collapsing>{total}</TableCell>
                    <TableCell collapsing>
                        <Button
                            circular
                            basic
                            icon='eye'
                            onClick={() => this.props.handleViewDoc(client)}
                        />
                    </TableCell>
                </TableRow>
            )
        }

        return rows
    }

    computeLocationTotals = (locationValue) => {
        let received = 0
        let processing = 0
        let ready = 0
        let returned = 0

        if (!this.props.clients) {
            return { received, processing, ready, returned, total: 0 }
        }

        for (const client of this.props.clients) {
            if (!client || !client.clientDocs) continue

            const matchingRecords = []
            for (const record of client.clientDocs) {
                const recordLocation = this.getRecordLocation(record)
                if (locationValue === '__UNASSIGNED__') {
                    if (recordLocation === '__UNASSIGNED__') matchingRecords.push(record)
                } else {
                    if (recordLocation === locationValue) matchingRecords.push(record)
                }
            }

            if (!matchingRecords.length) continue

            received += this.getDocCountOfStatus('Received', matchingRecords)
            processing += this.getDocCountOfStatus('In Processing', matchingRecords)
            ready += this.getDocCountOfStatus('Ready to Return', matchingRecords)
            returned += this.getDocCountOfStatus('Returned', matchingRecords)
        }

        const total = received + processing + ready + returned
        return { received, processing, ready, returned, total }
    }

    renderSummaryCards() {
        const items = locations.map((l) => {
            const t = this.computeLocationTotals(l.value)
            const isActive = this.state.selectedLocation === l.value
            const isUnassigned = l.value === '__UNASSIGNED__'

            return (
                <GridColumn key={l.key} width={4}>
                    <Segment
                        style={{ cursor: 'pointer' }}
                        color={isActive ? (isUnassigned ? 'grey' : 'red') : undefined}
                        onClick={() => this.setState({ selectedLocation: l.value })}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: 0 }}>
                                {l.text}
                                {isUnassigned && (
                                    <span style={{ fontSize: 12, color: '#999', marginLeft: 6 }}>
                                        (no location set)
                                    </span>
                                )}
                            </h3>
                            <Icon name='map marker alternate' />
                        </div>

                        {/* Status labels: force into 2 rows with spacing between rows */}
                        <div style={{ marginTop: 10 }}>
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                <Label basic color='purple'>Received: {t.received}</Label>
                                <Label basic color='blue'>In Processing: {t.processing}</Label>
                            </div>

                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                                <Label basic color='red'>Ready: {t.ready}</Label>
                                <Label basic color='black'>Returned: {t.returned}</Label>
                            </div>
                        </div>

                        <div style={{ marginTop: 10 }}>
                            <strong>Total: {t.total}</strong>
                        </div>
                    </Segment>
                </GridColumn>
            )
        })

        return (
            <Grid columns={4} stackable doubling>
                {items}
            </Grid>
        )
    }

    render() {
        if (!this.props.clients) {
            return <Loader active size='large'>Loading</Loader>
        }

        return (
            <Container>
                <br /><br />

                <Grid>
                    <GridColumn floated='left' width={6}>
                        <h2>Documents by Location</h2>
                        <div style={{ marginTop: 6, color: '#666' }}>
                            Purpose: each location knows which documents are under their care
                        </div>
                    </GridColumn>

                    <GridColumn width={5}>
                        <Input
                            fluid
                            placeholder='Search company / group / ROC...'
                            onChange={this.handleChangeSearchField}
                        />
                    </GridColumn>

                    <GridColumn floated='right' width={5} textAlign='right'>
                        <Button basic color='black' onClick={this.props.onBack}>
                            <Icon name='reply' />
                            Back
                        </Button>
                    </GridColumn>
                </Grid>

                <br />
                {this.renderSummaryCards()}
                <br />

                <Grid>
                    <GridColumn width={6}>
                        <Select
                            fluid
                            options={locations}
                            value={this.state.selectedLocation}
                            onChange={(e, { value }) => this.setState({ selectedLocation: value })}
                        />
                    </GridColumn>
                </Grid>

                <br />

                <Table celled striped compact>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Company Name</TableHeaderCell>
                            <TableHeaderCell width='2'>ROC</TableHeaderCell>
                            <TableHeaderCell collapsing>Received</TableHeaderCell>
                            <TableHeaderCell collapsing>In Processing</TableHeaderCell>
                            <TableHeaderCell collapsing>Ready to Return</TableHeaderCell>
                            <TableHeaderCell collapsing>Returned</TableHeaderCell>
                            <TableHeaderCell collapsing>Total</TableHeaderCell>
                            <TableHeaderCell />
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {this.buildLocationRows(this.state.selectedLocation)}
                    </TableBody>
                </Table>

                <br /><br /><br />
            </Container>
        )
    }

    handleChangeSearchField = (e) => {
        const { value } = e.target

        if (value.length < 2 && !this.state.isSearching) return

        if (value.length < 2) {
            this.setState({ isSearching: false, searchString: '' })
        } else {
            this.setState({ isSearching: true, searchString: value })
        }
    }
}

function mapStateToProps({ clients }) {
    return { clients }
}

export default connect(mapStateToProps, actions)(DocumentLocations)